// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"02711802","437":"0bc4dabb","537":"bb1518a2","562":"f36c0f40","787":"6f81f643","931":"34479060","982":"210e5b96","988":"cd20d806"}[chunkId] + ".chunk.js";
};